import React, { useState, useEffect} from "react";
import Button from '../../../Components/Button';
import { MDBInput, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Modal from '../../../Components/Modal';
import UserValidator from "../../../Components/UserValidator";
const FileRename = (props) => {  
  const [newfileName, setNewFileName] = useState(props.filename);  
  const validator = UserValidator();

  const onSubmit = (event) => {
    event.preventDefault();
    if (validator.allValid()) {
        props.fileUpdate(newfileName)
    }else {
        validator.showMessages();
    }
    }
    useEffect(() => {
        validator.purgeFields();
    }, [props])

  return (
    <Modal isOpen={props.isOpen} onClose={()=>props.modelClose()} size="md">
      <Modal.Header>Update File Information</Modal.Header>
      <Modal.Body>
          <MDBRow>
                <MDBCol size='12'>
                    <div className="mb-3">
                        <MDBInput label="File Name" className="mb-2" name="filename" type="text" value={newfileName} onChange={(e) => setNewFileName(e.target.value)}/>
                        {validator.message('filename', newfileName, 'fileNameValidation')}
                    </div>
                </MDBCol>
          </MDBRow>
      </Modal.Body>
      <Modal.Footer>
          <Button onClick={onSubmit}>
              Save
          </Button>
      </Modal.Footer>
  </Modal>
  );
};

export default FileRename;
